import { html, LitElement } from 'lit';
import { styles } from '../../../view/styles';
import { translateFn } from '../../../../../utils/translator.helper';
import { customElement, property, query } from 'lit/decorators.js';
import {
  ApiOptions,
  ApplicationOptions,
  AutomationAccountHookOptions,
  AutomationAccountOptions,
  BitbucketRepositoryOptions,
  BucketOptions,
  CertificateAuthorityOptions,
  commonOptions,
  ConfluencePageOptions,
  ConnectionOptions,
  CustomRulesEvents,
  detectionOptions,
  DetectionRuleType,
  edrOptions,
  EmailOptions,
  exclusionOptions,
  FileOptions,
  FilterFields,
  FlowOptions,
  GridType,
  JiraProjectOptions,
  KeyVaultOptions,
  LaunchTemplateOptions,
  Operators,
  PolicyOptions,
  ProcessOptions,
  RegistryOptions,
  RoleOptions,
  Type,
  ServicePrincipalOptions,
  SharingLinkOptions,
  SshKeyOptions,
  UrlOptions,
  UserGroupOptions,
  UserLoginOptions,
  xdrOptions,
  FILE_OPERATION_OPTIONS,
  CONNECTION_FILE_REMOTE_OPERATION_OPTIONS,
  REGISTRY_OPERATION_OPTIONS, ALERT_NAME,
} from '../../../../customRulesGrid/types';
import { GzChipsGeneratorInputWebComponent } from '../../../../../ui/gzChipsGeneratorInput';
import { validateInputValue } from '../../../utils';
import { LabelWidthValues } from "../../../../../types/common/types";
import { InputWidthValues } from "../../../../../ui/gzInput";
import { ButtonColor, FontSize } from "../../../../../ui/gzIconButton/types";
import { GzEnumFilterWebComponent } from '../../../../../ui/gzEnumFilter';

@customElement('gz-rule-criteria')
export class GzRuleCriteriaWebComponent extends LitElement {
  @property({ type: String, attribute: false, reflect: false })
  gridType;

  @property({ type: Boolean })
  isGZ = false;

  @property({ type: Object, attribute: true, reflect: true })
  disabledOptions;

  @property({ type: Boolean, attribute: true, reflect: true })
  public hasDeleteButton: boolean;

  @property({ type: String, attribute: true, reflect: true })
  public categoryValue: string | number = '';

  @query('#criteria')
  private criteriaSelect;

  @query('#operator')
  private operatorSelect;

  @query('#input')
  private ruleInput;

  @property({ type: Object, attribute: false, reflect: false })
  ruleCriteria: any = null;

  ruleTypeText = {
    [Type.EDR]: 'EDR',
    [Type.XDR]: 'XDR',
  }

  criteria = {
    [DetectionRuleType.PROCESS]: [
      {
        label: translateFn('Name'),
        value: ProcessOptions.NAME,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.PROCESS, ProcessOptions.NAME),
      },
      {
        label: translateFn('Path'),
        value: ProcessOptions.PATH,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.PROCESS, ProcessOptions.PATH),
      },
      {
        label: translateFn('Full path name'),
        value: ProcessOptions.FULL_PATH,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.PROCESS, ProcessOptions.FULL_PATH),
      },
      {
        label: translateFn('Command line'),
        value: ProcessOptions.COMMAND_LINE,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.PROCESS, ProcessOptions.COMMAND_LINE),
      },
      {
        label: translateFn('Parent name'),
        value: ProcessOptions.PARENT_NAME,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.PROCESS, ProcessOptions.PARENT_NAME),
      },
      {
        label: translateFn('Parent path'),
        value: ProcessOptions.PARENT_PATH,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.PROCESS, ProcessOptions.PARENT_PATH),
      },
      {
        label: translateFn('Parent full path name'),
        value: ProcessOptions.PARENT_FULL_NAME,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.PROCESS, ProcessOptions.PARENT_FULL_NAME),
      },
      {
        label: translateFn('Parent command line'),
        value: ProcessOptions.PARENT_COMMAND_LINE,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.PROCESS, ProcessOptions.PARENT_COMMAND_LINE),
      },
      {
        label: translateFn('User'),
        value: ProcessOptions.USER,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.PROCESS, ProcessOptions.USER),
      },
      {
        label: translateFn('MD5'),
        value: ProcessOptions.MD5,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.PROCESS, ProcessOptions.MD5),
      },
      {
        label: translateFn('SHA256'),
        value: ProcessOptions.SHA256,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.PROCESS, ProcessOptions.SHA256),
      },
      {
        label: translateFn('Alert name'),
        value: ProcessOptions.ALERT_NAME,
      },
    ],
    [DetectionRuleType.FILE]: [
      {
        label: translateFn('Name'),
        value: FileOptions.NAME,
      },
      {
        label: translateFn('Path'),
        value: FileOptions.PATH,
      },
      {
        label: translateFn('Full path name'),
        value: FileOptions.FULL_PATH,
      },
      {
        label: translateFn('Creation process name'),
        value: FileOptions.CREATION_PROCESS_NAME,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.FILE, FileOptions.CREATION_PROCESS_NAME),
      },
      {
        label: translateFn('Creation process path'),
        value: FileOptions.CREATION_PROCESS_PATH,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.FILE, FileOptions.CREATION_PROCESS_PATH),
      },
      {
        label: translateFn('Creation process full path name'),
        value: FileOptions.CREATION_PROCESS_FULL_PATH,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.FILE, FileOptions.CREATION_PROCESS_FULL_PATH),
      },
      {
        label: translateFn('Creation process command line'),
        value: FileOptions.CREATION_PROCESS_COMMAND_LINE,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.FILE, FileOptions.CREATION_PROCESS_COMMAND_LINE),
      },
      {
        label: translateFn('Operation'),
        value: FileOptions.OPERATION,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.FILE, FileOptions.OPERATION),
      },
      {
        label: translateFn('MD5'),
        value: FileOptions.MD5,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.FILE, FileOptions.MD5),
      },
      {
        label: translateFn('SHA256'),
        value: FileOptions.SHA256,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.FILE, FileOptions.SHA256),
      },
      {
        label: translateFn('URL'),
        value: FileOptions.URL,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.FILE, FileOptions.URL),
      },
      {
        label: translateFn('Creation process user'),
        value: FileOptions.CREATION_PROCESS_USER,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.FILE, FileOptions.CREATION_PROCESS_USER),
      },
      {
        label: translateFn('Alert name'),
        value: FileOptions.ALERT_NAME,
      },
    ],
    [DetectionRuleType.CONNECTION]: [
      {
        label: translateFn('Source IP'),
        value: ConnectionOptions.SOURCE_IP,
      },
      {
        label: translateFn('Destination IP'),
        value: ConnectionOptions.DESTINATION_IP,
      },
      {
        label: translateFn('Source port'),
        value: ConnectionOptions.SOURCE_PORT,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.CONNECTION, ConnectionOptions.SOURCE_PORT),
      },
      {
        label: translateFn('Destination port'),
        value: ConnectionOptions.DESTINATION_PORT,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.CONNECTION, ConnectionOptions.DESTINATION_PORT),
      },
      {
        label: translateFn('Creation process name'),
        value: ConnectionOptions.CREATION_PROCESS_NAME,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.CONNECTION, ConnectionOptions.CREATION_PROCESS_NAME),
      },
      {
        label: translateFn('Creation process path'),
        value: ConnectionOptions.CREATION_PROCESS_PATH,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.CONNECTION, ConnectionOptions.CREATION_PROCESS_PATH),
      },
      {
        label: translateFn('Creation process full path name'),
        value: ConnectionOptions.CREATION_PROCESS_FULL_PATH,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.CONNECTION, ConnectionOptions.CREATION_PROCESS_FULL_PATH),
      },
      {
        label: translateFn('Creation process command line'),
        value: ConnectionOptions.CREATION_PROCESS_COMMAND_LINE,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.CONNECTION, ConnectionOptions.CREATION_PROCESS_COMMAND_LINE),
      },
      {
        label: translateFn('Creation process user'),
        value: ConnectionOptions.CREATION_PROCESS_USER,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.CONNECTION, ConnectionOptions.CREATION_PROCESS_USER),
      },
      {
        label: translateFn('URL'),
        value: ConnectionOptions.URL,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.CONNECTION, ConnectionOptions.URL),
      },
      {
        label: translateFn('HTTP user'),
        value: ConnectionOptions.HTTP_USER,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.CONNECTION, ConnectionOptions.HTTP_USER),
      },
      {
        label: translateFn('HTTP downloaded file'),
        value: ConnectionOptions.HTTP_DOWNLOADED_FILE,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.CONNECTION, ConnectionOptions.HTTP_DOWNLOADED_FILE),
      },
      {
        label: translateFn('HTTP uploaded file'),
        value: ConnectionOptions.HTTP_UPLOADED_FILE,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.CONNECTION, ConnectionOptions.HTTP_UPLOADED_FILE),
      },
      {
        label: translateFn('FTP user'),
        value: ConnectionOptions.FTP_USER,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.CONNECTION, ConnectionOptions.FTP_USER),
      },
      {
        label: translateFn('SMB domain'),
        value: ConnectionOptions.SMB_DOMAIN,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.CONNECTION, ConnectionOptions.SMB_DOMAIN),
      },
      {
        label: translateFn('SMB share path'),
        value: ConnectionOptions.SMB_SHARE_PATH,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.CONNECTION, ConnectionOptions.SMB_SHARE_PATH),
      },
      {
        label: translateFn('SMB user'),
        value: ConnectionOptions.SMB_USER,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.CONNECTION, ConnectionOptions.SMB_USER),
      },
      {
        label: translateFn('SSH user'),
        value: ConnectionOptions.SSH_USER,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.CONNECTION, ConnectionOptions.SSH_USER),
      },
      {
        label: translateFn('WMI exec query'),
        value: ConnectionOptions.WMI_EXEC_QUERY,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.CONNECTION, ConnectionOptions.WMI_EXEC_QUERY),
      },
      {
        label: translateFn('Telnet user'),
        value: ConnectionOptions.TELNET_USER,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.CONNECTION, ConnectionOptions.TELNET_USER),
      },
      {
        label: translateFn('File remote operation'),
        value: ConnectionOptions.FILE_REMOTE_OPERATION,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.CONNECTION, ConnectionOptions.FILE_REMOTE_OPERATION),
      },
      {
        label: translateFn('File remote path'),
        value: ConnectionOptions.FILE_REMOTE_PATH,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.CONNECTION, ConnectionOptions.FILE_REMOTE_PATH),
      },
      {
        label: translateFn('Source user'),
        value: ConnectionOptions.SOURCE_USER,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.CONNECTION, ConnectionOptions.SOURCE_USER),
      },
      {
        label: translateFn('Destination user'),
        value: ConnectionOptions.DESTINATION_USER,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.CONNECTION, ConnectionOptions.DESTINATION_USER),
      },
      {
        label: translateFn('File name'),
        value: ConnectionOptions.FILE_NAME,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.CONNECTION, ConnectionOptions.FILE_NAME),
      },
      {
        label: translateFn('Email subject'),
        value: ConnectionOptions.EMAIL_SUBJECT,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.CONNECTION, ConnectionOptions.EMAIL_SUBJECT),
      },
      {
        label: translateFn('Application name'),
        value: ConnectionOptions.APPLICATION_NAME,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.CONNECTION, ConnectionOptions.APPLICATION_NAME),
      },
      {
        label: translateFn('Key vault name'),
        value: ConnectionOptions.KEY_VAULT_NAME,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.CONNECTION, ConnectionOptions.KEY_VAULT_NAME),
      },
      {
        label: translateFn('Role name'),
        value: ConnectionOptions.ROLE_NAME,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.CONNECTION, ConnectionOptions.ROLE_NAME),
      },
      {
        label: translateFn('Policy name'),
        value: ConnectionOptions.POLICY_NAME,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.CONNECTION, ConnectionOptions.POLICY_NAME),
      },
      {
        label: translateFn('Sharing link name'),
        value: ConnectionOptions.SHARING_LINK_NAME,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.CONNECTION, ConnectionOptions.SHARING_LINK_NAME),
      },
      {
        label: translateFn('Flow name'),
        value: ConnectionOptions.FLOW_NAME,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.CONNECTION, ConnectionOptions.FLOW_NAME),
      },
      {
        label: translateFn('URL name'),
        value: ConnectionOptions.URL_NAME,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.CONNECTION, ConnectionOptions.URL_NAME),
      },
      {
        label: translateFn('SSH key name'),
        value: ConnectionOptions.SSH_KEY_NAME,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.CONNECTION, ConnectionOptions.SSH_KEY_NAME),
      },
      {
        label: translateFn('Launch template name'),
        value: ConnectionOptions.LAUNCH_TEMPLATE_NAME,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.CONNECTION, ConnectionOptions.LAUNCH_TEMPLATE_NAME),
      },
      {
        label: translateFn('Service principal name'),
        value: ConnectionOptions.SERVICE_PRINCIPAL_NAME,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.CONNECTION, ConnectionOptions.SERVICE_PRINCIPAL_NAME),
      },
      {
        label: translateFn('User group name'),
        value: ConnectionOptions.USER_GROUP_NAME,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.CONNECTION, ConnectionOptions.USER_GROUP_NAME),
      },
      {
        label: translateFn('Automation account name'),
        value: ConnectionOptions.AUTOMATION_ACCOUNT_NAME,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.CONNECTION, ConnectionOptions.AUTOMATION_ACCOUNT_NAME),
      },
      {
        label: translateFn('Automation account hook name'),
        value: ConnectionOptions.AUTOMATION_ACCOUNT_HOOK_NAME,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.CONNECTION, ConnectionOptions.AUTOMATION_ACCOUNT_HOOK_NAME),
      },
      {
        label: translateFn('API name'),
        value: ConnectionOptions.API_NAME,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.CONNECTION, ConnectionOptions.API_NAME),
      },
      {
        label: translateFn('Certificate Authority name'),
        value: ConnectionOptions.CERTIFICATE_AUTHORITY_NAME,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.CONNECTION, ConnectionOptions.CERTIFICATE_AUTHORITY_NAME),
      },
      {
        label: translateFn('Bucket name'),
        value: ConnectionOptions.BUCKET_NAME,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.CONNECTION, ConnectionOptions.BUCKET_NAME),
      },
      {
        label: translateFn('Bitbucket repository name'),
        value: ConnectionOptions.BITBUCKET_REPOSITORY_NAME,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.CONNECTION, ConnectionOptions.BITBUCKET_REPOSITORY_NAME),
      },
      {
        label: translateFn('Jira project name'),
        value: ConnectionOptions.JIRA_PROJECT_NAME,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.CONNECTION, ConnectionOptions.JIRA_PROJECT_NAME),
      },
      {
        label: translateFn('Confluence page name'),
        value: ConnectionOptions.CONFLUENCE_PAGE_NAME,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.CONNECTION, ConnectionOptions.CONFLUENCE_PAGE_NAME),
      },
      {
        label: translateFn('Alert name'),
        value: ConnectionOptions.ALERT_NAME,
      },
    ],
    [DetectionRuleType.REGISTRY]: [
      {
        label: translateFn('Key'),
        value: RegistryOptions.KEY,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.REGISTRY, RegistryOptions.KEY),
      },
      {
        label: translateFn('Value'),
        value: RegistryOptions.VALUE,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.REGISTRY, RegistryOptions.VALUE),
      },
      {
        label: translateFn('Operation'),
        value: RegistryOptions.OPERATION,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.REGISTRY, RegistryOptions.OPERATION),
      },
      {
        label: translateFn('Creation process name'),
        value: RegistryOptions.CREATION_PROCESS_NAME,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.REGISTRY, RegistryOptions.CREATION_PROCESS_NAME),
      },
      {
        label: translateFn('Creation process path'),
        value: RegistryOptions.CREATION_PROCESS_PATH,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.REGISTRY, RegistryOptions.CREATION_PROCESS_PATH),
      },
      {
        label: translateFn('Creation process full path name'),
        value: RegistryOptions.CREATION_PROCESS_FULL_PATH,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.REGISTRY, RegistryOptions.CREATION_PROCESS_FULL_PATH),
      },
      {
        label: translateFn('Creation process command line'),
        value: RegistryOptions.CREATION_PROCESS_COMMAND_LINE,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.REGISTRY, RegistryOptions.CREATION_PROCESS_COMMAND_LINE),
      },
      {
        label: translateFn('Alert name'),
        value: RegistryOptions.ALERT_NAME,
      },
    ],
    [DetectionRuleType.USER_LOGIN]: [
      {
        label: translateFn('Name'),
        value: UserLoginOptions.NAME,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.USER_LOGIN, UserLoginOptions.NAME),
      },
      {
        label: translateFn('Source user'),
        value: UserLoginOptions.SOURCE_USER,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.USER_LOGIN, UserLoginOptions.SOURCE_USER),
      },
      {
        label: translateFn('Destination user'),
        value: UserLoginOptions.DESTINATION_USER,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.USER_LOGIN, UserLoginOptions.DESTINATION_USER),
      },
      {
        label: translateFn('Domain'),
        value: UserLoginOptions.DOMAIN,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.USER_LOGIN, UserLoginOptions.DOMAIN),
      },
      {
        label: translateFn('Source IP'),
        value: UserLoginOptions.SOURCE_IP,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.USER_LOGIN, UserLoginOptions.SOURCE_USER),
      },
      {
        label: translateFn('Destination IP'),
        value: UserLoginOptions.DESTINATION_IP,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.USER_LOGIN, UserLoginOptions.DESTINATION_USER),
      },
      {
        label: translateFn('File name'),
        value: UserLoginOptions.FILE_NAME,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.USER_LOGIN, UserLoginOptions.FILE_NAME),
      },
      {
        label: translateFn('Email subject'),
        value: UserLoginOptions.EMAIL_SUBJECT,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.USER_LOGIN, UserLoginOptions.EMAIL_SUBJECT),
      },
      {
        label: translateFn('Application name'),
        value: UserLoginOptions.APPLICATION_NAME,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.USER_LOGIN, UserLoginOptions.APPLICATION_NAME),
      },
      {
        label: translateFn('Key vault name'),
        value: UserLoginOptions.KEY_VAULT_NAME,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.USER_LOGIN, UserLoginOptions.KEY_VAULT_NAME),
      },
      {
        label: translateFn('Role name'),
        value: UserLoginOptions.ROLE_NAME,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.USER_LOGIN, UserLoginOptions.ROLE_NAME),
      },
      {
        label: translateFn('Policy name'),
        value: UserLoginOptions.POLICY_NAME,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.USER_LOGIN, UserLoginOptions.POLICY_NAME),
      },
      {
        label: translateFn('Sharing link name'),
        value: UserLoginOptions.SHARING_LINK_NAME,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.USER_LOGIN, UserLoginOptions.SHARING_LINK_NAME),
      },
      {
        label: translateFn('Flow name'),
        value: UserLoginOptions.FLOW_NAME,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.USER_LOGIN, UserLoginOptions.FLOW_NAME),
      },
      {
        label: translateFn('URL name'),
        value: UserLoginOptions.URL_NAME,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.USER_LOGIN, UserLoginOptions.URL_NAME),
      },
      {
        label: translateFn('SSH key name'),
        value: UserLoginOptions.SSH_KEY_NAME,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.USER_LOGIN, UserLoginOptions.SSH_KEY_NAME),
      },
      {
        label: translateFn('Launch template name'),
        value: UserLoginOptions.LAUNCH_TEMPLATE_NAME,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.USER_LOGIN, UserLoginOptions.LAUNCH_TEMPLATE_NAME),
      },
      {
        label: translateFn('Service principal name'),
        value: UserLoginOptions.SERVICE_PRINCIPAL_NAME,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.USER_LOGIN, UserLoginOptions.SERVICE_PRINCIPAL_NAME),
      },
      {
        label: translateFn('User group name'),
        value: UserLoginOptions.USER_GROUP_NAME,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.USER_LOGIN, UserLoginOptions.USER_GROUP_NAME),
      },
      {
        label: translateFn('Automation account name'),
        value: UserLoginOptions.AUTOMATION_ACCOUNT_NAME,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.USER_LOGIN, UserLoginOptions.AUTOMATION_ACCOUNT_NAME),
      },
      {
        label: translateFn('Automation account hook name'),
        value: UserLoginOptions.AUTOMATION_ACCOUNT_HOOK_NAME,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.USER_LOGIN, UserLoginOptions.AUTOMATION_ACCOUNT_HOOK_NAME),
      },
      {
        label: translateFn('API name'),
        value: UserLoginOptions.API_NAME,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.USER_LOGIN, UserLoginOptions.API_NAME),
      },
      {
        label: translateFn('Certificate Authority name'),
        value: UserLoginOptions.CERTIFICATE_AUTHORITY_NAME,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.USER_LOGIN, UserLoginOptions.CERTIFICATE_AUTHORITY_NAME),
      },
      {
        label: translateFn('Bucket name'),
        value: UserLoginOptions.BUCKET_NAME,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.USER_LOGIN, UserLoginOptions.BUCKET_NAME),
      },
      {
        label: translateFn('Bitbucket repository name'),
        value: UserLoginOptions.BITBUCKET_REPOSITORY_NAME,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.USER_LOGIN, UserLoginOptions.BITBUCKET_REPOSITORY_NAME),
      },
      {
        label: translateFn('Jira project name'),
        value: UserLoginOptions.JIRA_PROJECT_NAME,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.USER_LOGIN, UserLoginOptions.JIRA_PROJECT_NAME),
      },
      {
        label: translateFn('Confluence page name'),
        value: UserLoginOptions.CONFLUENCE_PAGE_NAME,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.USER_LOGIN, UserLoginOptions.CONFLUENCE_PAGE_NAME),
      },
      {
        label: translateFn('Alert name'),
        value: UserLoginOptions.ALERT_NAME,
      },
    ],
    [DetectionRuleType.EMAIL]: [
      {
        label: translateFn('Subject'),
        value: EmailOptions.SUBJECT,
      },
      {
        label: translateFn('Sender'),
        value: EmailOptions.SENDER,
      },
      {
        label: translateFn('Receiver'),
        value: EmailOptions.RECEIVER,
      },
      {
        label: translateFn('Attachment'),
        value: EmailOptions.ATTACHMENT,
      },
      {
        label: translateFn('URL'),
        value: EmailOptions.URL,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.EMAIL, EmailOptions.URL),
      },
      {
        label: translateFn('Alert name'),
        value: EmailOptions.ALERT_NAME,
      },
    ],
    [DetectionRuleType.APPLICATION]: [
      {
        label: translateFn('Name'),
        value: ApplicationOptions.NAME,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.APPLICATION, ApplicationOptions.NAME),
      },
      {
        label: translateFn('Id'),
        value: ApplicationOptions.ID,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.APPLICATION, ApplicationOptions.ID),
      },
      {
        label: translateFn('Application address'),
        value: ApplicationOptions.APPLICATION_ADDRESS,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.APPLICATION, ApplicationOptions.APPLICATION_ADDRESS),
      },
      {
        label: translateFn('Source IP'),
        value: ApplicationOptions.SOURCE_IP,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.APPLICATION, ApplicationOptions.SOURCE_IP),
      },
      {
        label: translateFn('Destination IP'),
        value: ApplicationOptions.DESTINATION_IP,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.APPLICATION, ApplicationOptions.DESTINATION_IP),
      },
      {
        label: translateFn('Source user'),
        value: ApplicationOptions.SOURCE_USER,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.APPLICATION, ApplicationOptions.SOURCE_USER),
      },
      {
        label: translateFn('Destination user'),
        value: ApplicationOptions.DESTINATION_USER,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.APPLICATION, ApplicationOptions.DESTINATION_USER),
      },
      {
        label: translateFn('Alert name'),
        value: ApplicationOptions.ALERT_NAME,
      },
    ],
    [DetectionRuleType.KEY_VAULT]: [
      {
        label: translateFn('Name'),
        value: KeyVaultOptions.NAME,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.KEY_VAULT, KeyVaultOptions.NAME),
      },
      {
        label: translateFn('Source IP'),
        value: KeyVaultOptions.SOURCE_IP,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.KEY_VAULT, KeyVaultOptions.SOURCE_IP),
      },
      {
        label: translateFn('Destination IP'),
        value: KeyVaultOptions.DESTINATION_IP,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.KEY_VAULT, KeyVaultOptions.DESTINATION_IP),
      },
      {
        label: translateFn('Source user'),
        value: KeyVaultOptions.SOURCE_USER,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.KEY_VAULT, KeyVaultOptions.SOURCE_USER),
      },
      {
        label: translateFn('Destination user'),
        value: KeyVaultOptions.DESTINATION_USER,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.KEY_VAULT, KeyVaultOptions.DESTINATION_USER),
      },
      {
        label: translateFn('Alert name'),
        value: KeyVaultOptions.ALERT_NAME,
      },
    ],
    [DetectionRuleType.ROLE]: [
      {
        label: translateFn('Name'),
        value: RoleOptions.NAME,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.ROLE, RoleOptions.NAME),
      },
      {
        label: translateFn('Id'),
        value: RoleOptions.ID,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.ROLE, RoleOptions.ID),
      },
      {
        label: translateFn('Source IP'),
        value: RoleOptions.SOURCE_IP,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.ROLE, RoleOptions.SOURCE_IP),
      },
      {
        label: translateFn('Destination IP'),
        value: RoleOptions.DESTINATION_IP,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.ROLE, RoleOptions.DESTINATION_IP),
      },
      {
        label: translateFn('Source user'),
        value: RoleOptions.SOURCE_USER,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.ROLE, RoleOptions.SOURCE_USER),
      },
      {
        label: translateFn('Destination user'),
        value: RoleOptions.DESTINATION_USER,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.ROLE, RoleOptions.DESTINATION_USER),
      },
      {
        label: translateFn('Alert name'),
        value: RoleOptions.ALERT_NAME,
      },
    ],
    [DetectionRuleType.POLICY]: [
      {
        label: translateFn('Name'),
        value: PolicyOptions.NAME,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.POLICY, PolicyOptions.NAME),
      },
      {
        label: translateFn('Id'),
        value: PolicyOptions.ID,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.POLICY, PolicyOptions.ID),
      },
      {
        label: translateFn('Resource policy type'),
        value: PolicyOptions.RESOURCE_POLICY_TYPE,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.POLICY, PolicyOptions.RESOURCE_POLICY_TYPE),
      },
      {
        label: translateFn('Source IP'),
        value: PolicyOptions.SOURCE_IP,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.POLICY, PolicyOptions.SOURCE_IP),
      },
      {
        label: translateFn('Destination IP'),
        value: PolicyOptions.DESTINATION_IP,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.POLICY, PolicyOptions.DESTINATION_IP),
      },
      {
        label: translateFn('Source user'),
        value: PolicyOptions.SOURCE_USER,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.POLICY, PolicyOptions.SOURCE_USER),
      },
      {
        label: translateFn('Destination user'),
        value: PolicyOptions.DESTINATION_USER,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.POLICY, PolicyOptions.DESTINATION_USER),
      },
      {
        label: translateFn('Alert name'),
        value: PolicyOptions.ALERT_NAME,
      },
    ],
    [DetectionRuleType.SHARING_LINK]: [
      {
        label: translateFn('Name'),
        value: SharingLinkOptions.NAME,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.SHARING_LINK, SharingLinkOptions.NAME),
      },
      {
        label: translateFn('URL'),
        value: SharingLinkOptions.URL,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.SHARING_LINK, SharingLinkOptions.URL),
      },
      {
        label: translateFn('Source IP'),
        value: SharingLinkOptions.SOURCE_IP,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.SHARING_LINK, SharingLinkOptions.SOURCE_IP),
      },
      {
        label: translateFn('Destination IP'),
        value: SharingLinkOptions.DESTINATION_IP,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.SHARING_LINK, SharingLinkOptions.DESTINATION_IP),
      },
      {
        label: translateFn('Source user'),
        value: SharingLinkOptions.SOURCE_USER,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.SHARING_LINK, SharingLinkOptions.SOURCE_USER),
      },
      {
        label: translateFn('Destination user'),
        value: SharingLinkOptions.DESTINATION_USER,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.SHARING_LINK, SharingLinkOptions.DESTINATION_USER),
      },
      {
        label: translateFn('Alert name'),
        value: SharingLinkOptions.ALERT_NAME,
      },
    ],
    [DetectionRuleType.FLOW]: [
      {
        label: translateFn('Name'),
        value: FlowOptions.NAME,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.FLOW, FlowOptions.NAME),
      },
      {
        label: translateFn('Id'),
        value: FlowOptions.ID,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.FLOW, FlowOptions.ID),
      },
      {
        label: translateFn('URL'),
        value: FlowOptions.URL,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.FLOW, FlowOptions.URL),
      },
      {
        label: translateFn('Source IP'),
        value: FlowOptions.SOURCE_IP,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.FLOW, FlowOptions.SOURCE_IP),
      },
      {
        label: translateFn('Destination IP'),
        value: FlowOptions.DESTINATION_IP,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.FLOW, FlowOptions.DESTINATION_IP),
      },
      {
        label: translateFn('Source user'),
        value: FlowOptions.SOURCE_USER,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.FLOW, FlowOptions.SOURCE_USER),
      },
      {
        label: translateFn('Destination user'),
        value: FlowOptions.DESTINATION_USER,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.FLOW, FlowOptions.DESTINATION_USER),
      },
      {
        label: translateFn('Alert name'),
        value: FlowOptions.ALERT_NAME,
      },
    ],
    [DetectionRuleType.URL]: [
      {
        label: translateFn('Name'),
        value: UrlOptions.NAME,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.URL, UrlOptions.NAME),
      },
      {
        label: translateFn('URL'),
        value: UrlOptions.URL,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.URL, UrlOptions.URL),
      },
      {
        label: translateFn('Source IP'),
        value: UrlOptions.SOURCE_IP,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.URL, UrlOptions.SOURCE_IP),
      },
      {
        label: translateFn('Destination IP'),
        value: UrlOptions.DESTINATION_IP,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.URL, UrlOptions.DESTINATION_IP),
      },
      {
        label: translateFn('Source user'),
        value: UrlOptions.SOURCE_USER,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.URL, UrlOptions.SOURCE_USER),
      },
      {
        label: translateFn('Destination user'),
        value: UrlOptions.DESTINATION_USER,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.URL, UrlOptions.DESTINATION_USER),
      },
      {
        label: translateFn('Alert name'),
        value: UrlOptions.ALERT_NAME,
      },
    ],
    [DetectionRuleType.SSH_KEY]: [
      {
        label: translateFn('Name'),
        value: SshKeyOptions.NAME,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.SSH_KEY, SshKeyOptions.NAME),
      },
      {
        label: translateFn('SSH public key'),
        value: SshKeyOptions.SSH_PUBLIC_KEY,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.SSH_KEY, SshKeyOptions.SSH_PUBLIC_KEY),
      },
      {
        label: translateFn('Source IP'),
        value: SshKeyOptions.SOURCE_IP,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.SSH_KEY, SshKeyOptions.SOURCE_IP),
      },
      {
        label: translateFn('Destination IP'),
        value: SshKeyOptions.DESTINATION_IP,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.SSH_KEY, SshKeyOptions.DESTINATION_IP),
      },
      {
        label: translateFn('Source user'),
        value: SshKeyOptions.SOURCE_USER,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.SSH_KEY, SshKeyOptions.SOURCE_USER),
      },
      {
        label: translateFn('Destination user'),
        value: SshKeyOptions.DESTINATION_USER,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.SSH_KEY, SshKeyOptions.DESTINATION_USER),
      },
      {
        label: translateFn('Alert name'),
        value: SshKeyOptions.ALERT_NAME,
      },
    ],
    [DetectionRuleType.LAUNCH_TEMPLATE]: [
      {
        label: translateFn('Name'),
        value: LaunchTemplateOptions.NAME,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.LAUNCH_TEMPLATE, LaunchTemplateOptions.NAME),
      },
      {
        label: translateFn('Id'),
        value: LaunchTemplateOptions.ID,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.LAUNCH_TEMPLATE, LaunchTemplateOptions.ID),
      },
      {
        label: translateFn('Source IP'),
        value: LaunchTemplateOptions.SOURCE_IP,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.LAUNCH_TEMPLATE, LaunchTemplateOptions.SOURCE_IP),
      },
      {
        label: translateFn('Destination IP'),
        value: LaunchTemplateOptions.DESTINATION_IP,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.LAUNCH_TEMPLATE, LaunchTemplateOptions.DESTINATION_IP),
      },
      {
        label: translateFn('Source user'),
        value: LaunchTemplateOptions.SOURCE_USER,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.LAUNCH_TEMPLATE, LaunchTemplateOptions.SOURCE_USER),
      },
      {
        label: translateFn('Destination user'),
        value: LaunchTemplateOptions.DESTINATION_USER,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.LAUNCH_TEMPLATE, LaunchTemplateOptions.DESTINATION_USER),
      },
      {
        label: translateFn('Alert name'),
        value: LaunchTemplateOptions.ALERT_NAME,
      },
    ],
    [DetectionRuleType.SERVICE_PRINCIPAL]: [
      {
        label: translateFn('Name'),
        value: ServicePrincipalOptions.NAME,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.SERVICE_PRINCIPAL, ServicePrincipalOptions.NAME),
      },
      {
        label: translateFn('Id'),
        value: ServicePrincipalOptions.ID,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.SERVICE_PRINCIPAL, ServicePrincipalOptions.ID),
      },
      {
        label: translateFn('Source IP'),
        value: ServicePrincipalOptions.SOURCE_IP,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.SERVICE_PRINCIPAL, ServicePrincipalOptions.SOURCE_IP),
      },
      {
        label: translateFn('Destination IP'),
        value: ServicePrincipalOptions.DESTINATION_IP,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.SERVICE_PRINCIPAL, ServicePrincipalOptions.DESTINATION_IP),
      },
      {
        label: translateFn('Source user'),
        value: ServicePrincipalOptions.SOURCE_USER,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.SERVICE_PRINCIPAL, ServicePrincipalOptions.SOURCE_USER),
      },
      {
        label: translateFn('Destination user'),
        value: ServicePrincipalOptions.DESTINATION_USER,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.SERVICE_PRINCIPAL, ServicePrincipalOptions.DESTINATION_USER),
      },
      {
        label: translateFn('Alert name'),
        value: ServicePrincipalOptions.ALERT_NAME,
      },
    ],
    [DetectionRuleType.USER_GROUP]: [
      {
        label: translateFn('Name'),
        value: UserGroupOptions.NAME,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.USER_GROUP, UserGroupOptions.NAME),
      },
      {
        label: translateFn('Id'),
        value: UserGroupOptions.ID,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.USER_GROUP, UserGroupOptions.ID),
      },
      {
        label: translateFn('Source IP'),
        value: UserGroupOptions.SOURCE_IP,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.USER_GROUP, UserGroupOptions.SOURCE_IP),
      },
      {
        label: translateFn('Destination IP'),
        value: UserGroupOptions.DESTINATION_IP,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.USER_GROUP, UserGroupOptions.DESTINATION_IP),
      },
      {
        label: translateFn('Source user'),
        value: UserGroupOptions.SOURCE_USER,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.USER_GROUP, UserGroupOptions.SOURCE_USER),
      },
      {
        label: translateFn('Destination user'),
        value: UserGroupOptions.DESTINATION_USER,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.USER_GROUP, UserGroupOptions.DESTINATION_USER),
      },
      {
        label: translateFn('Alert name'),
        value: UserGroupOptions.ALERT_NAME,
      },
    ],
    [DetectionRuleType.AUTOMATION_ACCOUNT]: [
      {
        label: translateFn('Name'),
        value: AutomationAccountOptions.NAME,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.AUTOMATION_ACCOUNT, AutomationAccountOptions.NAME),
      },
      {
        label: translateFn('Id'),
        value: AutomationAccountOptions.ID,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.AUTOMATION_ACCOUNT, AutomationAccountOptions.ID),
      },
      {
        label: translateFn('Source IP'),
        value: AutomationAccountOptions.SOURCE_IP,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.AUTOMATION_ACCOUNT, AutomationAccountOptions.SOURCE_IP),
      },
      {
        label: translateFn('Destination IP'),
        value: AutomationAccountOptions.DESTINATION_IP,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.AUTOMATION_ACCOUNT, AutomationAccountOptions.DESTINATION_IP),
      },
      {
        label: translateFn('Source user'),
        value: AutomationAccountOptions.SOURCE_USER,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.AUTOMATION_ACCOUNT, AutomationAccountOptions.SOURCE_USER),
      },
      {
        label: translateFn('Destination user'),
        value: AutomationAccountOptions.DESTINATION_USER,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.AUTOMATION_ACCOUNT, AutomationAccountOptions.DESTINATION_USER),
      },
      {
        label: translateFn('Alert name'),
        value: AutomationAccountOptions.ALERT_NAME,
      },
    ],
    [DetectionRuleType.AUTOMATION_ACCOUNT_HOOK]: [
      {
        label: translateFn('Name'),
        value: AutomationAccountHookOptions.NAME,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.AUTOMATION_ACCOUNT_HOOK, AutomationAccountHookOptions.NAME),
      },
      {
        label: translateFn('Id'),
        value: AutomationAccountHookOptions.ID,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.AUTOMATION_ACCOUNT_HOOK, AutomationAccountHookOptions.ID),
      },
      {
        label: translateFn('Source IP'),
        value: AutomationAccountHookOptions.SOURCE_IP,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.AUTOMATION_ACCOUNT_HOOK, AutomationAccountHookOptions.SOURCE_IP),
      },
      {
        label: translateFn('Destination IP'),
        value: AutomationAccountHookOptions.DESTINATION_IP,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.AUTOMATION_ACCOUNT_HOOK, AutomationAccountHookOptions.DESTINATION_IP),
      },
      {
        label: translateFn('Source user'),
        value: AutomationAccountHookOptions.SOURCE_USER,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.AUTOMATION_ACCOUNT_HOOK, AutomationAccountHookOptions.SOURCE_USER),
      },
      {
        label: translateFn('Destination user'),
        value: AutomationAccountHookOptions.DESTINATION_USER,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.AUTOMATION_ACCOUNT_HOOK, AutomationAccountHookOptions.DESTINATION_USER),
      },
      {
        label: translateFn('Alert name'),
        value: AutomationAccountHookOptions.ALERT_NAME,
      },
    ],
    [DetectionRuleType.API]: [
      {
        label: translateFn('Name'),
        value: ApiOptions.NAME,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.API, ApiOptions.NAME),
      },
      {
        label: translateFn('Id'),
        value: ApiOptions.ID,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.API, ApiOptions.ID),
      },
      {
        label: translateFn('Source IP'),
        value: ApiOptions.SOURCE_IP,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.API, ApiOptions.SOURCE_IP),
      },
      {
        label: translateFn('Destination IP'),
        value: ApiOptions.DESTINATION_IP,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.API, ApiOptions.DESTINATION_IP),
      },
      {
        label: translateFn('Source user'),
        value: ApiOptions.SOURCE_USER,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.API, ApiOptions.SOURCE_USER),
      },
      {
        label: translateFn('Destination user'),
        value: ApiOptions.DESTINATION_USER,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.API, ApiOptions.DESTINATION_USER),
      },
      {
        label: translateFn('Alert name'),
        value: ApiOptions.ALERT_NAME,
      },
    ],
    [DetectionRuleType.CERTIFICATE_AUTHORITY]: [
      {
        label: translateFn('Name'),
        value: CertificateAuthorityOptions.NAME,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.CERTIFICATE_AUTHORITY, CertificateAuthorityOptions.NAME),
      },
      {
        label: translateFn('Source IP'),
        value: CertificateAuthorityOptions.SOURCE_IP,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.CERTIFICATE_AUTHORITY, CertificateAuthorityOptions.SOURCE_IP),
      },
      {
        label: translateFn('Destination IP'),
        value: CertificateAuthorityOptions.DESTINATION_IP,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.CERTIFICATE_AUTHORITY, CertificateAuthorityOptions.DESTINATION_IP),
      },
      {
        label: translateFn('Source user'),
        value: CertificateAuthorityOptions.SOURCE_USER,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.CERTIFICATE_AUTHORITY, CertificateAuthorityOptions.SOURCE_USER),
      },
      {
        label: translateFn('Destination user'),
        value: CertificateAuthorityOptions.DESTINATION_USER,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.CERTIFICATE_AUTHORITY, CertificateAuthorityOptions.DESTINATION_USER),
      },
      {
        label: translateFn('Alert name'),
        value: CertificateAuthorityOptions.ALERT_NAME,
      },
    ],
    [DetectionRuleType.BUCKET]: [
      {
        label: translateFn('Name'),
        value: BucketOptions.NAME,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.BUCKET, BucketOptions.NAME),
      },
      {
        label: translateFn('Source IP'),
        value: BucketOptions.SOURCE_IP,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.BUCKET, BucketOptions.SOURCE_IP),
      },
      {
        label: translateFn('Destination IP'),
        value: BucketOptions.DESTINATION_IP,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.BUCKET, BucketOptions.DESTINATION_IP),
      },
      {
        label: translateFn('Source user'),
        value: BucketOptions.SOURCE_USER,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.BUCKET, BucketOptions.SOURCE_USER),
      },
      {
        label: translateFn('Destination user'),
        value: BucketOptions.DESTINATION_USER,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.BUCKET, BucketOptions.DESTINATION_USER),
      },
      {
        label: translateFn('Alert name'),
        value: BucketOptions.ALERT_NAME,
      },
    ],
    [DetectionRuleType.BITBUCKET_REPOSITORY]: [
      {
        label: translateFn('Name'),
        value: BitbucketRepositoryOptions.NAME,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.BITBUCKET_REPOSITORY, BitbucketRepositoryOptions.NAME),
      },
      {
        label: translateFn('Id'),
        value: BitbucketRepositoryOptions.ID,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.BITBUCKET_REPOSITORY, BitbucketRepositoryOptions.ID),
      },
      {
        label: translateFn('URL'),
        value: BitbucketRepositoryOptions.URL,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.BITBUCKET_REPOSITORY, BitbucketRepositoryOptions.URL),
      },
      {
        label: translateFn('Source IP'),
        value: BitbucketRepositoryOptions.SOURCE_IP,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.BITBUCKET_REPOSITORY, BitbucketRepositoryOptions.SOURCE_IP),
      },
      {
        label: translateFn('Destination IP'),
        value: BitbucketRepositoryOptions.DESTINATION_IP,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.BITBUCKET_REPOSITORY, BitbucketRepositoryOptions.DESTINATION_IP),
      },
      {
        label: translateFn('Source user'),
        value: BitbucketRepositoryOptions.SOURCE_USER,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.BITBUCKET_REPOSITORY, BitbucketRepositoryOptions.SOURCE_USER),
      },
      {
        label: translateFn('Destination user'),
        value: BitbucketRepositoryOptions.DESTINATION_USER,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.BITBUCKET_REPOSITORY, BitbucketRepositoryOptions.DESTINATION_USER),
      },
      {
        label: translateFn('Alert name'),
        value: BitbucketRepositoryOptions.ALERT_NAME,
      },
    ],
    [DetectionRuleType.JIRA_PROJECT]: [
      {
        label: translateFn('Name'),
        value: JiraProjectOptions.NAME,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.JIRA_PROJECT, JiraProjectOptions.NAME),
      },
      {
        label: translateFn('Id'),
        value: JiraProjectOptions.ID,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.JIRA_PROJECT, JiraProjectOptions.ID),
      },
      {
        label: translateFn('Domain'),
        value: JiraProjectOptions.DOMAIN,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.JIRA_PROJECT, JiraProjectOptions.DOMAIN),
      },
      {
        label: translateFn('Source IP'),
        value: JiraProjectOptions.SOURCE_IP,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.JIRA_PROJECT, JiraProjectOptions.SOURCE_IP),
      },
      {
        label: translateFn('Destination IP'),
        value: JiraProjectOptions.DESTINATION_IP,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.JIRA_PROJECT, JiraProjectOptions.DESTINATION_IP),
      },
      {
        label: translateFn('Source user'),
        value: JiraProjectOptions.SOURCE_USER,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.JIRA_PROJECT, JiraProjectOptions.SOURCE_USER),
      },
      {
        label: translateFn('Destination user'),
        value: JiraProjectOptions.DESTINATION_USER,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.JIRA_PROJECT, JiraProjectOptions.DESTINATION_USER),
      },
      {
        label: translateFn('Alert name'),
        value: JiraProjectOptions.ALERT_NAME,
      },
    ],
    [DetectionRuleType.CONFLUENCE_PAGE]: [
      {
        label: translateFn('Name'),
        value: ConfluencePageOptions.NAME,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.CONFLUENCE_PAGE, ConfluencePageOptions.NAME),
      },
      {
        label: translateFn('Id'),
        value: ConfluencePageOptions.ID,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.CONFLUENCE_PAGE, ConfluencePageOptions.ID),
      },
      {
        label: translateFn('URL'),
        value: ConfluencePageOptions.URL,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.CONFLUENCE_PAGE, ConfluencePageOptions.URL),
      },
      {
        label: translateFn('Source IP'),
        value: ConfluencePageOptions.SOURCE_IP,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.CONFLUENCE_PAGE, ConfluencePageOptions.SOURCE_IP),
      },
      {
        label: translateFn('Destination IP'),
        value: ConfluencePageOptions.DESTINATION_IP,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.CONFLUENCE_PAGE, ConfluencePageOptions.DESTINATION_IP),
      },
      {
        label: translateFn('Source user'),
        value: ConfluencePageOptions.SOURCE_USER,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.CONFLUENCE_PAGE, ConfluencePageOptions.SOURCE_USER),
      },
      {
        label: translateFn('Destination user'),
        value: ConfluencePageOptions.DESTINATION_USER,
        itemSuffixRenderer: item => this.listItemSuffixRenderer(item, DetectionRuleType.CONFLUENCE_PAGE, ConfluencePageOptions.DESTINATION_USER),
      },
      {
        label: translateFn('Alert name'),
        value: ConfluencePageOptions.ALERT_NAME,
      },
    ],
  };

  /**
   * Operator options for rule criteria
   * @type {({label: string, value: Operators} | {label: string, value: Operators} | {label: string, value: Operators})[]}
   */
  operatorOptions = [
    {
      label: translateFn('Is'),
      value: Operators.IS,
    },
    {
      label: translateFn('Contains'),
      value: Operators.CONTAINS,
    },
    {
      label: translateFn('Is one of'),
      value: Operators.IS_ONE_OF,
    },
  ];

  /**
   * Operator options for the "alert name" filter
   * @type {{label: string, value: Operators}[]}
   */
  alertOperatorOptions = [
    {
      label: translateFn('Is'),
      value: Operators.IS,
    }
  ]

  listItemSuffixRenderer = (item, category, criteria) => {
    if (this.gridType === GridType.DETECTION || this.isGZ) {
      return html``;
    }

    const hasEdrLabel = edrOptions[category] ? edrOptions[category].includes(criteria) : false;
    const hasXdrLabel = xdrOptions[category] ? xdrOptions[category].includes(criteria) : false;

    let label = '';
    if (hasEdrLabel) {
      label = this.ruleTypeText[Type.EDR];
    } else if (hasXdrLabel) {
      label = this.ruleTypeText[Type.XDR];
    }

    return html`<gz-chip .text="${label}" ?disabled="${item.disabled}" notSelectable></gz-chip>`;
  }

  static get styles() {
    return styles;
  }

  render() {
    const criteriaGridOptions = this.gridType === GridType.DETECTION ? detectionOptions : exclusionOptions;
    const criteriaAvailableOptions = this.categoryValue ? criteriaGridOptions[this.categoryValue] : [];

    let criteriaOptions = this.categoryValue ? this.criteria[this.categoryValue] : [];
    criteriaOptions = criteriaOptions.filter(criteria => criteriaAvailableOptions.includes(criteria.value));

    if (this.isGZ) {
      let edrCategoryOptions = this.categoryValue ? edrOptions[this.categoryValue] : [];
      let commonCategoryOptions = this.categoryValue ? commonOptions[this.categoryValue] : [];

      edrCategoryOptions = edrCategoryOptions ?? [];
      commonCategoryOptions = commonCategoryOptions ?? [];

      criteriaOptions = criteriaOptions.filter(criteria =>
        edrCategoryOptions.includes(criteria.value) || commonCategoryOptions.includes(criteria.value));
    }

    criteriaOptions.map(option => option.disabled = this.checkIfCriteriaIsDisabled(option));

    criteriaOptions.sort((a, b) => this.sortCriterias(this.categoryValue, a.value, b.value));

    const operatorOptions = this.getOperatorOptions();

    if (operatorOptions.length === 1) {
      this.ruleCriteria.operatorValue = operatorOptions[0].value;
    }

    return html`
      <gz-single-select
        class="mr-2"
        .filterOptions="${criteriaOptions}"
        .placeholder="${translateFn('Select criteria')}"
        .hasDynamicSearch="${false}"
        .value="${this.ruleCriteria.criteriaValue}"
        @selectionChange="${this.handleCriteriaChange}"
        labelWidth="${LabelWidthValues.LARGE}"
        id="criteria"
      ></gz-single-select>
      <gz-single-select-loaded
        class="mr-2"
        .filterOptions="${operatorOptions}"
        .placeholder="${translateFn('Select operator')}"
        .value="${this.ruleCriteria.operatorValue}"
        .readonly="${operatorOptions.length === 1}"
        @selectionChange="${this.handleOperatorChange}"
        id="operator"
      ></gz-single-select-loaded>
      ${this.renderInput()}
      <div class=${this.hasDeleteButton ? 'delete-rule-btn' : 'hidden'}>
        <gz-icon-button
          icon="ds-icon-delete_large"
          fontsize="${FontSize.ICON_SIZE_16}"
          buttoncolor="${ButtonColor.SECONDARY}"
          @click="${this.handleDelete}"
        ></gz-icon-button>
      </div>
    `;
  }

  private checkIfCriteriaIsDisabled(criteria) {
    if (!this.disabledOptions || !this.disabledOptions[this.categoryValue]) {
      return false;
    }

    return this.disabledOptions[this.categoryValue].includes(criteria.value.toString());
  }

  private renderInput() {
    if (this.categoryValue === DetectionRuleType.FILE && this.ruleCriteria.criteriaValue === FileOptions.OPERATION) {
      const options = [
        {
          label: translateFn('Create'),
          value: FILE_OPERATION_OPTIONS.CREATE,
        },
        {
          label: translateFn('Read'),
          value: FILE_OPERATION_OPTIONS.READ,
        },
        {
          label: translateFn('Write'),
          value: FILE_OPERATION_OPTIONS.WRITE,
        },
        {
          label: translateFn('Move'),
          value: FILE_OPERATION_OPTIONS.MOVE,
        },
        {
          label: translateFn('Rename'),
          value: FILE_OPERATION_OPTIONS.RENAME,
        },
        {
          label: translateFn('Copy'),
          value: FILE_OPERATION_OPTIONS.COPY,
        },
      ];
      return this.renderDropdownInput(options);
    }

    if (this.categoryValue === DetectionRuleType.REGISTRY && this.ruleCriteria.criteriaValue === RegistryOptions.OPERATION) {
      const options = [
        {
          label: translateFn('Key created'),
          value: REGISTRY_OPERATION_OPTIONS.KEY_CREATED,
        },
        {
          label: translateFn('Key deleted'),
          value: REGISTRY_OPERATION_OPTIONS.KEY_DELETED,
        },
        {
          label: translateFn('Key renamed'),
          value: REGISTRY_OPERATION_OPTIONS.KEY_RENAMED,
        },
        {
          label: translateFn('Value created'),
          value: REGISTRY_OPERATION_OPTIONS.VALUE_CREATED,
        },
        {
          label: translateFn('Value deleted'),
          value: REGISTRY_OPERATION_OPTIONS.VALUE_DELETED,
        },
        {
          label: translateFn('Value written'),
          value: REGISTRY_OPERATION_OPTIONS.VALUE_WRITTEN,
        },
      ];
      return this.renderDropdownInput(options);
    }

    if (this.categoryValue === DetectionRuleType.CONNECTION && this.ruleCriteria.criteriaValue === ConnectionOptions.FILE_REMOTE_OPERATION) {
      const options = [
        {
          label: translateFn('Create'),
          value: CONNECTION_FILE_REMOTE_OPERATION_OPTIONS.CREATE,
        },
        {
          label: translateFn('Delete'),
          value: CONNECTION_FILE_REMOTE_OPERATION_OPTIONS.DELETE,
        },
        {
          label: translateFn('Read'),
          value: CONNECTION_FILE_REMOTE_OPERATION_OPTIONS.READ,
        },
        {
          label: translateFn('Write'),
          value: CONNECTION_FILE_REMOTE_OPERATION_OPTIONS.WRITE,
        },
        {
          label: translateFn('Move'),
          value: CONNECTION_FILE_REMOTE_OPERATION_OPTIONS.MOVE,
        },
      ];
      return this.renderDropdownInput(options);
    }

    if (this.ruleCriteria.operatorValue === Operators.IS_ONE_OF) {
      return html` <gz-chips-generator-input
        themeInput
        class="mr-1"
        id="input"
        hideCopyToClipboardButton="true"
        .chipList="${this.ruleCriteria.inputValue ?? []}"
        @change="${this.handleMultipleInputChange}"
        .strings="${{ placeholder: translateFn('Type values here') }}}"
      ></gz-chips-generator-input>`;
    }
    return html` <gz-input
      class="mr-05"
      inputWidth="${InputWidthValues.XXLARGE}"
      id="input"
      .placeholder="${translateFn('Type value here')}"
      .value="${this.ruleCriteria.inputValue}"
      @change="${this.handleSingleInputChange}"
    ></gz-input>`;
  }

  private getStringFromAllFilterOptions(filterOptions) {
    return filterOptions.map(option => option.label).join(', ');
  }

  private renderDropdownInput(options) {
    if (this.ruleCriteria.operatorValue === Operators.IS_ONE_OF) {
      const filterOptions = options.map(option => {
        option.selected = this.ruleCriteria.inputValue?.includes(option.value) ?? false;
        return option;
      });

      return html` <gz-enum-filter
        class="mr-05"
        .filterOptions="${filterOptions}"
        .placeholder="${translateFn('Select')}"
        .allItemsLabel="${this.getStringFromAllFilterOptions(filterOptions)}"
        @selectionChange="${this.handleDropdownMultipleInputChange}"
        labelWidth="${LabelWidthValues.XXLARGE}"
        .confirmActionButtonString="${translateFn('APPLY')}"
        .allowSelectNone="${false}"
        id="input"
      ></gz-enum-filter>`;
    }
    let selectInputValue;
    if (Array.isArray(this.ruleCriteria.inputValue)) {
      selectInputValue = this.ruleCriteria.inputValue[0];
    } else {
      selectInputValue = this.ruleCriteria.inputValue;
    }

    return html` <gz-single-select
        class="mr-05"
        .filterOptions="${options}"
        .placeholder="${translateFn('Select')}"
        .hasDynamicSearch="${false}"
        .value="${selectInputValue}"
        @selectionChange="${this.handleDropdownInputChange}"
        labelWidth="${LabelWidthValues.XXLARGE}"
        id="input"
      ></gz-single-select>`;
  }

  private getOperatorOptions() {
    if (this.ruleCriteria.criteriaValue === FilterFields.ALERT_NAME) {
      return this.alertOperatorOptions;
    }

    if (
      (this.categoryValue === DetectionRuleType.FILE && this.ruleCriteria.criteriaValue === FileOptions.OPERATION) ||
      (this.categoryValue === DetectionRuleType.REGISTRY && this.ruleCriteria.criteriaValue === RegistryOptions.OPERATION) ||
      (this.categoryValue === DetectionRuleType.CONNECTION && this.ruleCriteria.criteriaValue === ConnectionOptions.FILE_REMOTE_OPERATION)
    ) {
      return [
        {
          label: translateFn('Is'),
          value: Operators.IS,
        },
        {
          label: translateFn('Is one of'),
          value: Operators.IS_ONE_OF,
        },
      ]
    }

    return this.operatorOptions;

  }

  public markFieldsWithError() {
    if (this.ruleCriteria.criteriaValue == null) {
      this.criteriaSelect.invalid = true;
      this.criteriaSelect.errorTooltipText = translateFn('This field is required');
    }

    if (this.ruleCriteria.operatorValue == null) {
      this.operatorSelect.invalid = true;
      this.operatorSelect.errorTooltipText = translateFn('This field is required');
    }

    if (!this.ruleCriteria.inputValue) {
      this.markRuleInputAsInvalid(translateFn('This field is required'));
    } else if (
      !validateInputValue(
        this.ruleCriteria.inputValue,
        this.categoryValue,
        this.ruleCriteria.criteriaValue,
        this.ruleCriteria.operatorValue
      )
    ) {
      this.markRuleInputAsInvalid(translateFn('Field value is invalid'));
    }
  }

  markRuleInputAsInvalid(message) {
    this.ruleInput.active = true;
    if (this.ruleInput instanceof GzChipsGeneratorInputWebComponent) {
      this.ruleInput.setInputError(message);
    } else if (this.ruleInput instanceof GzEnumFilterWebComponent) {
      this.ruleInput.isError = true;
      this.ruleInput.errorMessage = message;
    } else {
      this.ruleInput.invalid = true;
      this.ruleInput.errorTooltipText = message;
    }
  }

  private handleDropdownInputChange(e: CustomEvent) {
    this.ruleCriteria.inputValue = e.detail.selectedValue;
    this.ruleInput.invalid = false;
  }

  private handleDropdownMultipleInputChange(e: CustomEvent) {
    this.ruleCriteria.inputValue = e.detail.selectedValues;
    this.ruleInput.invalid = false;
  }

  private handleMultipleInputChange(e: CustomEvent) {
    this.ruleCriteria.inputValue = e.detail.value;
    this.ruleInput.invalid = false;
  }

  private handleSingleInputChange(e: CustomEvent) {
    this.ruleCriteria.inputValue = e.detail.sourceEvent;
    this.ruleInput.invalid = false;
  }

  private handleCriteriaChange(e: CustomEvent) {
    this.ruleCriteria.criteriaValue = e.detail.selectedValue;
    this.criteriaSelect.invalid = false;

    this.dispatchEvent(new CustomEvent(CustomRulesEvents.EDIT_CRITERIA));
  }

  private handleOperatorChange(e: CustomEvent) {
    let shouldRerender = false;
    if (this.ruleCriteria.operatorValue === Operators.IS_ONE_OF || e.detail.selectedValue === Operators.IS_ONE_OF) {
      this.resetInputValue();
      shouldRerender = true;
    }
    this.ruleCriteria.operatorValue = e.detail.selectedValue;
    this.operatorSelect.invalid = false;
    if (shouldRerender) {
      this.requestUpdate('ruleCriteria');
    }
  }

  private resetInputValue() {
    this.ruleCriteria.inputValue = [];
  }

  private handleDelete() {
    this.dispatchEvent(new CustomEvent(CustomRulesEvents.DELETE));

    this.remove();
  }

  private sortCriterias(categoryValue, criteriaValueA, criteriaValueB) {
    const edrCriterias = edrOptions[categoryValue] ?? [];
    const xdrCriterias = xdrOptions[categoryValue] ?? [];
    const commonCriterias = commonOptions[categoryValue] ?? [];

    const translatedCriteria = this.criteria[categoryValue].reduce((result, criteria) => {
      result[criteria.value] = criteria.label;
      return result;
    }, {});

    if (this.gridType === GridType.DETECTION || this.isGZ) {
      return translatedCriteria[criteriaValueA].localeCompare(translatedCriteria[criteriaValueB]);
    }

    const isAInEDR = edrCriterias.includes(criteriaValueA);
    const isAInXDR = xdrCriterias.includes(criteriaValueA);
    const isBInEDR = edrCriterias.includes(criteriaValueB);
    const isBInXDR = xdrCriterias.includes(criteriaValueB);
    const isACommonField = (!isAInEDR && !isAInXDR) || commonCriterias.includes(criteriaValueA) || criteriaValueA === ALERT_NAME;
    const isBCommonField = (!isBInEDR && !isBInXDR) || commonCriterias.includes(criteriaValueB) || criteriaValueB === ALERT_NAME;

    // common fields should be placed before edr or xdr fields
    if (isACommonField && (isBInEDR || isBInXDR)) {
      return -1;
    }
    if (isBCommonField && (isAInEDR || isAInXDR)) {
      return 1;
    }

    // edr fields should be placed before xdr fields
    if (isAInEDR && isBInXDR) {
      return -1;
    }
    if (isBInEDR && isAInXDR) {
      return 1;
    }

    // locale compare for the rest
    return translatedCriteria[criteriaValueA].localeCompare(translatedCriteria[criteriaValueB]);
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'gz-rule-criteria': GzRuleCriteriaWebComponent;
  }
}
